var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMailDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_81_1",
    "data-name": "Component 81 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.625,
    height: 25.219,
    viewBox: "0 0 33.625 25.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9078",
    "data-name": "Path 9078",
    d: "M30.473,64H3.152A3.153,3.153,0,0,0,0,67.152V86.066a3.153,3.153,0,0,0,3.152,3.152h27.32a3.153,3.153,0,0,0,3.152-3.152V67.152A3.153,3.153,0,0,0,30.473,64ZM3.152,66.1h27.32a1.054,1.054,0,0,1,1.051,1.051v2.719c-1.438,1.215-3.494,2.89-9.89,7.966-1.11.88-3.3,3-4.82,2.975-1.524.026-3.717-2.095-4.82-2.975C5.6,72.761,3.54,71.086,2.1,69.871V67.152A1.054,1.054,0,0,1,3.152,66.1Zm27.32,21.016H3.152A1.054,1.054,0,0,1,2.1,86.066V72.6c1.5,1.228,3.862,3.126,8.584,6.876,1.346,1.077,3.724,3.448,6.127,3.435,2.391.02,4.748-2.331,6.127-3.435,4.722-3.75,7.086-5.648,8.584-6.876V86.066A1.054,1.054,0,0,1,30.473,87.117Z",
    transform: "translate(0 -64)",
    fill: "#0033A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMailDark);
export default __webpack_public_path__ + "static/media/ico-mail-dark.514aa6930680fa382d0252be29096f7f.svg";
export { ForwardRef as ReactComponent };